<template>
    <div>
        <h5 class="grey-color fw-600">Измените спецификацию</h5>
        <fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table v-model="form.deliverables" :v="$v.form.deliverables" :is-loading="isLoading" />
        <b-form-invalid-feedback :state="!$v.form.deliverables.$invalid" class="my-2" style="padding-left: 5px; padding-right: 5px" v-if="$v.form.deliverables.$invalid">{{ specErrorMessage }}</b-form-invalid-feedback>
        <text-row-price :label-cols-lg="4" label="Общая стоимость, руб." :value="specSum" />
        <text-row-price :label-cols-lg="4" label="Общая стоимость контракта, руб." :value="purchase.purchase_terms.contract_price" />
        <form-row-edit-date :label-cols-lg="4" label="Дата заключения дополнительного соглашения" v-model="form.conclusion_date" :v="$v.form.conclusion_date" :min-date="purchase.contract.contract_conclusion_date" :max-date="$now()" compact />
        <form-row-single-line-document-upload v-model="form.attachment" :label-cols-lg="4" :v="$v.form.attachment" title="Дополнительное соглашение" compact />

        <b-button variant="custom-outline-secondary" class="text-uppercase mt-2" @click="onCancel">Отмена</b-button>
        <b-button variant="custom-green" class="text-uppercase mt-2 ml-2" :disabled="$v.$invalid" @click="createSupplementaryAgreement">Отправить дополнительное соглашение поставщику</b-button>
        <p class="font-weight-bold text-danger mt-3 mb-1 fs-14">Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса.</p>
    </div>
</template>

<script>
import { minValue, required } from 'vuelidate/lib/validators';
import roundToTwoDecimals from '@lib/js/src/misc/roundToTwoDecimals';
import Config from '@core/js/ddriven/application/config/Config';
import Fl44UnknownVolumeSupplementaryAgreementTerminationSpecificationsEditTable from '@/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-supplementary-agreement-termination-specifications-edit-table.vue';

export default {
    name: 'fl44-unknown-volume-create-supplementary-agreement-termination-agreement-of-parties-block',
    components: {
        Fl44UnknownVolumeSupplementaryAgreementTerminationSpecificationsEditTable
    },
    props: {
        purchase: {
            type: Object
        },
        terminationType: {
            type: String
        }
    },
    data() {
        return {
            isLoading: false,
            price: null,
            priceLimit: null,
            form: {
                conclusion_date: null,
                attachment: null,
                type: 'termination',
                deliverables: []
            }
        };
    },
    validations() {
        return {
            form: {
                conclusion_date: {
                    required
                },
                attachment: {
                    required
                },
                deliverables: {
                    required,
                    priceLimit() {
                        return this.specSum <= this.priceLimit;
                    },
                    $each: {
                        ktru_item: {
                            id: { required }
                        },
                        amount: { required, minValue: minValue(0) },
                        minAmount(item) {
                            return item.amount >= item.min_amount;
                        }
                    }
                }
            }
        };
    },
    mounted() {
        this.fillData();
    },
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        async fillData() {
            this.isLoading = true;
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .getSupplementaryAgreementTerminationTemplateData(this.purchase.id, this.purchase.contract.id)
                .then((response) => {
                    this.form.deliverables = response.deliverables;
                    this.contract_conclusion_date = response.contract_conclusion_date;
                    this.price = response.price;
                    this.priceLimit = response.price;
                })
                .catch(() => {
                    this.$emit('cancel');
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        async createSupplementaryAgreement() {
            this.isLoading = true;
            const formData = {
                ...this.form,
                deliverables: this.form.deliverables.map((deliverable) => {
                    return {
                        purchase_deliverable_id: deliverable.id,
                        ktru_item_id: deliverable.ktru_item_id,
                        amount: deliverable.amount,
                        price: deliverable.price
                    };
                }),
                price: this.specSum,
                termination_type: this.terminationType
            };
            await this.$api.products.fl44UnknownVolume.supplementaryAgreements
                .store(this.purchase.id, this.purchase.contract.id, formData)
                .then((response) => {
                    if (response) {
                        this.$emit('done');
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
    computed: {
        Config() {
            return Config;
        },
        features() {
            return Config.get('theme.features');
        },
        specSum() {
            return roundToTwoDecimals(
                this.form.deliverables.reduce((sum, item) => {
                    return (sum += roundToTwoDecimals(item.amount * item.price));
                }, 0)
            );
        },
        specErrorMessage() {
            const deliverables = Object.values(this.$v.form.deliverables.$each.$iter);
            if (deliverables.some((e) => e.amount.$invalid)) return 'У одной или более позиций в таблице спецификации не заполнено поле "Количество фактическое"';
            if (!this.$v.form.deliverables.priceLimit) return `Сумма по ДС о расторжении не должна превышать сумму контракта / ДС (${this.$formatPrice(this.priceLimit)} руб.)`;
            return '';
        }
    }
};
</script>
